export const veteranFields = {
  parentObject: 'veteran',
  fullName: 'fullName',
  ssn: 'ssn',
  vaFileNumber: 'vaFileNumber',
  dateOfBirth: 'dateOfBirth',
};

export const claimantFields = {
  parentObject: 'claimant',
  fullName: 'fullName',
  relationshipType: 'relationshipType',
  otherRelationshipDescription: 'otherRelationshipDescription',
  address: 'address',
  phone: 'phone',
  email: 'email',
  receivesApportionmentNow: 'receivesApportionmentNow',
  isStepchild: 'isStepchild',
  stepchildLivesWithVeteran: 'stepchildLivesWithVeteran',
  stepchildDepartureDate: 'stepchildDepartureDate',
  legallyAdoptedByAnotherPerson: 'legallyAdoptedByAnotherPerson',
};

export const requestedApportionmentPersonFields = {
  parentObject: 'requestedApportionmentPeople',
  fullName: 'fullName',
  ssn: 'ssn',
  veteranRelationshipDescription: 'veteranRelationshipDescription',
  otherRelationshipDescription: 'otherRelationshipDescription',
  receivesApportionmentNow: 'receivesApportionmentNow',
  isStepChild: 'isStepChild',
  stepchildLivesWithVeteran: 'stepchildLivesWithVeteran',
  stepchildDepartureDate: 'stepchildDepartureDate',
  adoptedChildrenQuestion: 'adoptedChildrenQuestion',
};

export const apportionmentFields = {
  parentObject: 'apportionment',
};

export const relationOptions = {
  currentSpouseOption: 'I’m the Veteran’s current spouse',
  child18To23InSchoolOption:
    'I’m the Veteran’s child age 18 to 23 and in school',
  custodianForChildUnder18Option:
    'I’m the custodian filing for the Veteran’s child under 18',
  dependentParentOption: 'I’m the Veteran’s dependent parent',
  childOver18IncapableOption:
    'I’m the Veteran’s child over 18 who is permanently incapable of self-support',
  otherOption: 'Other (I’ll describe my relationship to the Veteran)',
};

export const relationshipOptions = {
  currentSpouse: 'The Veteran’s current spouse',
  child18To23InSchool: 'The Veteran’s child 18-23 in school',
  custodianForChildUnder18: 'The Veteran’s minor child under 18',
  dependentParent: 'The Veteran’s dependent parent',
  childOver18Incapable:
    'The Veteran’s child over 18 permanently incapable of self-support',
  other: 'Other (I’ll describe this claimant’s relationship to the Veteran)',
};

export const POSTAL_CODE_ERROR_MESSAGES = {
  USA: {
    required: 'Enter a postal code',
    pattern: 'Please enter a valid 5-digit postal code',
  },
  CAN: {
    required: 'Enter a postal code',
    pattern: 'Please enter a valid 6-character postal code',
  },
  MEX: {
    required: 'Enter a postal code',
    pattern: 'Please enter a valid 5-digit postal code',
  },
  NONE: {
    required: 'Enter a postal code',
    pattern: 'Please enter a valid postal code',
  },
  OTHER: {
    required: 'Enter a postal code',
    pattern: 'Please enter a valid postal code',
  },
};

export const formTitles = {
  form: 'Apply for apportionment of a beneficiary’s award online',
  subTitle: '(VA Form 21-0788)',
  informationRequired: 'Information we are required to share',
  veteranInformation: 'Information about the Veteran',
  veteranInformationCont: 'Information about the Veteran',
  claimantRelationship: 'Your basic information',
  additionalRelationshipInformation: 'Additional relationship information',
  claimantInformation: 'Your basic information',
  claimantInformationCont: 'Your basic information',
  mailingAddress: 'Your basic information',
  apportionmentInformation: 'Claimant information',
  adoptionQuestion: 'Additional relationship information',
  reasonsForClaim: 'Reasons for claim',
  remarksInformation: 'Additional information about your claim',
  certificationInformation: 'Certification',
  reviewAndSubmitStep: 'Review and submit',
  reviewAndSubmitPageTitle: 'Review, sign, and submit',
};

export const introductionPageText = {
  formTitle: 'Apply for apportionment of a beneficiary’s award online',
  formSubTitle:
    "Information Regarding Apportionment of Beneficiary's Award (VA Form 21-0788)",
  authStartFormText:
    'Start your application for apportionment of a beneficiary’s award',
  unauthStartText: 'Sign in or create an account',
  saveInProgressText:
    'When you sign in with an identity-verified account, you can save your work in progress.',
  intro:
    'Use VA Form 21-0788 to request that part of a Veteran’s or surviving spouse’s VA monetary benefits be paid directly to you. You may apply if you are the spouse, child, or dependent parent of a Veteran (compensation benefits only), the dependent child of a surviving spouse, or the custodian of a Veteran’s or surviving spouse’s dependent child.',

  getStartedHeader: 'Follow these steps to get started',
  unauthStartLinkText:
    'Start your application for apportionment of a beneficiary’s award without signing in',

  eligibilityHeader: 'Check your eligibility',
  eligibilityIntro: 'You may be eligible if',
  eligibilityItems: [
    'You’re the Veteran’s spouse or dependent, and',
    'The Veteran or surviving spouse is in prison after being convicted of a felony, or',
    'The Veteran or surviving spouse receives a VA pension and is in jail or prison after being convicted of a misdemeanor, or',
    {
      text: 'You’re the dependent of a Veteran who:',
      subItems: [
        'Cannot manage their VA benefits on their own (has been determined incompetent), and',
        'Doesn’t have someone assigned to manage their VA benefits (fiduciary), and',
        'Is living in a care facility paid for by VA (institutionalized)',
      ],
    },
  ],

  whatYouNeedHeader: 'Gather your information',
  whatYouNeedText: 'Here’s what you’ll need to submit your request:',
  whatYouNeedItems: [
    {
      label: "Veteran's information",
      text: 'This includes the Veteran’s name, date of birth, Social Security number, and VA file number (if known).',
    },
    {
      label: 'Your personal information',
      text: 'This includes your name, mailing address, phone number, email address, and relationship to the Veteran.',
    },
    {
      label: 'Other Dependents Information (if applicable)',
      text: 'This includes the dependent’s name, date of birth, Social Security number, relationship to the Veteran, and current apportionment status (if applicable).',
    },
    {
      label: 'Reasons for this claim',
      text: 'Be prepared to explain why you’re requesting the apportionment.',
    },
  ],

  spouseNote: {
    label: 'Note for Veterans’ Spouses',
    text: "If you're married and requesting an apportionment as the spouse of a Veteran, your marriage must meet these criteria:",

    spouseItems: [
      'The state where you lived when you married recognizes this marriage, or',
      'The state where you lived when you filed your claim (or became eligible for benefits) recognizes your marriage',
    ],
  },

  startHeader: 'Start your application',
  startBody:
    "We'll take you through each step of the process. It should take about 15 minutes.",
  startBodyCont:
    'When you sign in with an identity-verified account, you can save your work in progress.',

  afterApply: {
    trigger: 'What happens after you apply',
    firstParagraph:
      'We’ll contact you by mail if we need more information. Once we review your request, we’ll mail all interested parties a letter with our decision.',
    secondParagraphStart:
      'If you don’t receive a letter from us about your request, don’t submit another request. Call us at',
    secondParagraphEnd:
      'We’re here Monday through Friday, 8:00 a.m. to 8:00 p.m. ET.',
  },
};

export const confirmationPageText = {
  thankYou: 'Thank you for submitting your request for apportionment.',
  nextStep:
    "After we review your form, we'll contact you if we need more information.",
  confirmationPrefix: 'Your confirmation number is',
};

export const informationRequiredText = {
  pageTitle: 'Information we are required to share',
  aboutFormTitle:
    "I understand that VA Form 21-0788 is used to request an apportionment of a beneficiary's award.",
  aboutFormHeadline: 'About VA Form 21-0788',
  aboutFormDescription:
    'In certain limited circumstances, a Veteran’s disability award or a surviving spouse’s award may be apportioned to a spouse, child, or dependent parent.',
  aboutFormError: 'You must acknowledge the purpose of this form to continue.',
  privacyActTitle:
    'I have read the Privacy Act and Respondent Burden information.',
  privacyActHeadline: 'Privacy Act and Respondent Burden',
  privacyActDescription:
    'The information you submit is used to determine benefits and may be disclosed for authorized routine uses under the Privacy Act.',
  privacyActError:
    'You must acknowledge the Privacy Act and Respondent Burden information to continue.',
};

export const veteranInformationText = {
  pageTitle: "Veteran's name and date of birth",
  pageDescription:
    'We need to collect some information about the Veteran first.',
  pageContTitle: "Veteran's ID information",
  pageContDescription:
    'You must enter a Social Security number or VA file number',
  basicInfoHeading: "Veteran's basic information",
  firstNameTitle: 'First name',
  middleInitialTitle: 'Middle initial',
  lastNameTitle: 'Last name',
  firstNameError: 'Please enter the Veteran’s first name',
  lastNameError: 'Please enter the Veteran’s last name',
  dateOfBirthTitle: 'Date of birth',
  dateOfBirthRequiredError: 'Please enter the Veteran’s date of birth',
  dateOfBirthIncompleteError: 'Please enter a complete date',
  dateOfBirthPatternError: 'Please enter a valid date of birth',
  ssnRequiredError: 'Please enter the Veteran’s social security number',
  ssnPatternError:
    'Please enter a valid 9 digit Social Security number (dashes allowed)',
  vaFileNumberTitle: 'VA file number',
  vaFileNumberHint:
    'Veterans who served before the mid-1970s may have a VA file number',
  vaFileNumberPatternError:
    'Please enter a valid 8 or 9-digit VA file number. This field is optional.',
};

export const claimantRelationshipText = {
  pageTitle: 'Your relationship to the Veteran',
  pageDescription:
    "This helps us determine what information you'll need to provide.",
  relationshipTitle: 'What’s your relationship to the Veteran?',
  otherRelationshipTitle:
    'Since you selected “Other” please describe your relationship to the Veteran ',
  relationshipRequiredError:
    'Please select your relationship to the Veteran. If your relationship is not listed, select “Other”.',
  otherRelationshipRequiredError:
    'Please specify your relationship to the Veteran',
};

export const claimantInformationText = {
  pageTitle: 'Your name',
  pageDescription:
    'We need your information because you are completing this form for yourself or someone else, such as a minor child or dependent parent.',
  nameTitle: 'Your name',
  firstNameTitle: 'Your first name',
  middleInitialTitle: 'Your middle initial',
  lastNameTitle: 'Your last name',
  firstNameError: 'Please enter your first name',
  lastNameError: 'Please enter your last name',

  pageTitleCont: 'Your phone number and email address',
  pageDescriptionCont: 'How can we reach you?',
  phoneTitle: 'Your telephone number',

  relationshipTitle: 'Relationship to the Veteran',
  otherRelationshipTitle: 'Other, please specify',
  relationshipRequiredError:
    "Please select the claimant's relationship to the Veteran",
  otherRelationshipRequiredError:
    "Please specify the claimant's relationship to the Veteran",
  addressPageTitle: 'Your address',
  addressPageDescription:
    'Provide your current mailing address and contact information.',
  streetLabel: 'Street address',
  apartmentUnitLabel: 'Apartment or unit number',
  cityLabel: 'City',
  stateLabel: 'State',
  zipCodeLabel: 'Postal code',
  streetRequiredError: 'Enter the Veteran or service member’s street address',
  usPhoneRequiredError:
    'Enter a valid United States of America phone number. Use 10 digits',
  otherCountryPhoneRequiredError:
    'Enter a valid phone number for the selected country',
  emailTitle: 'Your email address',
  emailHint:
    "We'll use this email address to confirm when we receive your form",
  emailError:
    'Enter a valid email address without spaces using this format: email@domain.com',
  receivesApportionmentNowError:
    'Select either “Yes” or “No” to tell us if this claimant already receives part of the Veteran’s benefit',
  stepchildPageTitle: 'Is [this person] the Veteran’s stepchild?',
  stepchildRequiredHelper:
    'Select either “Yes” or “No” to tell us if this person is a stepchild of the Veteran',
  stepchildYesLabel: 'Yes',
  stepchildYesDescription:
    'If yes, answer the follow-on question about this stepchild',
  stepchildNoLabel: 'No',
  stepchildRequiredError:
    'Select either “Yes” or “No” to tell us if this person is a stepchild of the Veteran',
  stepchildLivesWithVeteranTitle:
    'Is the stepchild still living in the Veteran’s household?',
  stepchildLivesWithVeteranHelper:
    'Select either “Yes” or “No” to let us know if this stepchild still lives in the Veteran’s household',
  stepchildLivesWithVeteranYesLabel: 'Yes',
  stepchildLivesWithVeteranNoLabel: 'No',
  stepchildLivesWithVeteranNoDescription:
    'If no, answer the follow-on question about this stepchild',
  stepchildLivesWithVeteranRequiredError:
    'Select either “Yes” or “No” to let us know if this stepchild still lives in the Veteran’s household',
  stepchildDepartureDateTitle:
    'Enter the date this stepchild left the Veteran’s household',
  stepchildDepartureDateHint:
    'Enter 1 or 2 digits for the month and day and 4 digits for the year.',
  stepchildDepartureDateRequiredError:
    'Complete the date fields to tell us when this stepchild left the Veteran’s household. Enter 4-digits for the year.',
};

export const additionalRelationshipInformationText = {
  pageTitle: 'Additional information about the Veteran’s children',
  legalAdoptionTitle: 'Has this person been legally adopted by another person?',
  legalAdoptionHelperText:
    'Select either “Yes” or “No” to tell us if the Veteran’s child has been legally adopted by someone else.',
  legalAdoptionRequiredError:
    'Select “Yes” or “No” to tell us if the claimant is a child of the Veteran and has been legally adopted by someone else',
};

export const mailingAddressText = {
  pageTitle: 'Your mailing address',
  pageDescription:
    "This is where we'll mail important information about your claim.",
  countryRequiredError: 'Please select a country',
  streetLabel: 'Street address',
  apartmentUnitLabel: 'Apartment or unit number',
  cityRequiredError: 'Enter a city',
  cityLabel: 'City',
  stateLabel: 'State',
  stateRequiredError: 'Please select a state',
  zipCodeLabel: 'Postal code',
  streetRequiredError: 'Enter a street address',
  postalCodeRequiredError: 'Enter a postal code',
};

export const apportionmentInformationText = {
  pageTitle: 'Section III: Apportionment information',
  pageDescription:
    'Only complete the portions of this section that apply to your request.',

  requestedPeopleSummaryTitle:
    'We need information about each benefit claimant',
  requestedPeopleSummaryHint:
    'You’ll need to add at least 1 person. You can add up to 4 people.',
  requestedPeopleSummaryDescription:
    'Tell us about who the requested benefit payment (apportionment) is for. You can add up to 4 claimants. If you are the claimant requesting this benefit, enter your information.',
  requestedPeopleReviewTitle: 'Review claimants',

  requestedPeopleItemTitle: 'Person you are requesting an apportionment for',
  requestedPeopleItemDescription:
    'Tell us about who the requested benefit payment (apportionment) is for. You can add up to 4 claimants.',

  requestedPeopleIdentityPageTitle:
    'Person you are requesting an apportionment for',
  requestedPeopleRelationshipPageTitle:
    "What is this person's relationship to the Veteran?",
  requestedPeopleReceiptPageTitle:
    'Does this person already receive part of the Veteran’s benefit (apportionment)?',
  requestedPeopleStepchildPageTitle: 'Is this person the Veteran’s stepchild?',
  requestedPeopleStepchildDatePageTitle:
    'Enter the date this stepchild left the Veteran’s household',
  requestedPeopleAdoptionPageTitle:
    'Additional information about the Veteran’s children',

  requestedPeopleNounSingular: 'claimant',
  requestedPeopleNounPlural: 'claimants',

  firstNameTitle: 'First name',
  middleInitialTitle: 'Middle initial',
  lastNameTitle: 'Last name',
  firstNameError: "Please enter the claimant's first name",
  lastNameError: "Please enter the claimant's last name",

  ssnRequiredError: "Please enter the claimant's social security number",
  ssnPatternError:
    'Please enter a valid 9 digit Social Security number (dashes allowed)',
  ssnMatchesVeteranError:
    'The claimant’s Social Security number must be different from the Veteran’s Social Security number',
  ssnMatchesAnotherClaimantError:
    'Each claimant must have a different Social Security number. This Social Security number is already used by another claimant.',

  relationshipTitle: 'Relationship to the Veteran',
  relationshipError: 'Please select the claimant’s relationship to the Veteran',
  otherRelationshipTitle:
    'Since you selected “Other” please describe this claimant’s relationship to the Veteran',
  otherRelationshipError:
    'Please specify the claimant’s relationship to the Veteran',

  currentlyReceivingTitle:
    'Does this person already receive part of the Veteran’s benefit (apportionment)?',
  receivesApportionmentNowHint:
    'Select either “Yes” or “No” to tell us if this claimant already receives part of the Veteran’s benefit',
  receivesApportionmentNowError:
    'Select either “Yes” or “No” to tell us if this claimant already receives part of the Veteran’s benefit',

  requestedPeopleError:
    'Please select "Yes" to add at least 1 person you are requesting an apportionment for.',

  isStepchildQuestionTitle: 'Is this person the Veteran’s stepchild?',
  isStepchildHint:
    'Select either “Yes” or “No” to tell us if this person is a stepchild of the Veteran',
  isStepchildYesLabel: 'Yes',
  isStepchildYesDescription:
    'If yes, answer the follow-on question about this stepchild',
  isStepchildNoLabel: 'No',
  isStepchildError:
    'Select either “Yes” or “No” to tell us if this person is a stepchild of the Veteran',

  stepchildLivesWithVeteranQuestionTitle:
    'Is the stepchild still living in the Veteran’s household?',
  stepchildLivesWithVeteranHint:
    'Select either “Yes” or “No” to let us know if this stepchild still lives in the Veteran’s household',
  stepchildLivesWithVeteranYesLabel: 'Yes',
  stepchildLivesWithVeteranNoLabel: 'No',
  stepchildLivesWithVeteranNoDescription:
    'If no, answer the follow-on question about this stepchild',
  stepchildLivesWithVeteranError:
    'Select either “Yes” or “No” to let us know if this stepchild still lives in the Veteran’s household',

  stepchildDepartureDateTitle:
    'Enter the date this stepchild left the Veteran’s household',
  stepchildDepartureDateHint: 'For example: January 19, 2022',
  stepchildDepartureDateError:
    'Complete the date fields to tell us when this stepchild left the Veteran’s household. Enter 4-digits for the year.',

  adoptedQuestionPageTitle:
    'Has this person been legally adopted by another person?',
  adoptedQuestionHint:
    'Select either “Yes” or “No” to tell us if the Veteran’s child has been legally adopted by someone else.',
  adoptedQuestionTitle: ' ',
  adoptedQuestionError:
    'Select “Yes” or “No” to tell us if the claimant is a child of the Veteran and has been legally adopted by someone else',

  // Page 1
  reasonsIntroPageTitle: 'Reasons for your apportionment claim',
  reasonsIntroDescription:
    'We’ll ask you some questions about the reasons for this claim. You’ll have an option to add additional information if you wish in the “Remarks” section.',
  reasonPageSubDescription:
    'You’ll have an option to add additional information if you wish in the “Remarks” section.',

  // Page 2
  veteranIncarcerationPageTitle: 'Veteran incarceration',
  veteranIncarceratedOver60DaysTitle:
    'Has the Veteran been incarcerated for more than 60 days as a result of a conviction (38 U.S.C 5313)?',
  veteranIncarcerationLabels: {
    yes: 'Yes',
    no: 'No',
  },
  veteranIncarcerationDescriptions: {
    yes: 'If yes, answer the 3 follow-on questions about the Veteran’s incarceration',
  },
  veteranIncarceratedError:
    'Is the Veteran in jail or prison? Select either “Yes” or “No”',
  convictionFelonyOrMisdemeanorTitle:
    'Was this conviction a felony or misdemeanor?',
  convictionTypeLabels: {
    felony: 'Felony',
    misdemeanor: 'Misdemeanor',
  },
  convictionTypeError: 'Select the type of conviction: felony or misdemeanor',
  veteranIncarcerationFacilityNameTitle:
    'Name of facility where the Veteran beneficiary is incarcerated',
  veteranIncarcerationFacilityNameError:
    'Enter the name of the incarceration facility',
  veteranIncarcerationFacilityAddressError:
    'Enter the incarceration facility address',

  // Page 3
  survivingSpouseIncarcerationPageTitle:
    'Surviving spouse or child incarceration',
  survivingBeneficiaryIncarceratedTitle:
    'Has the Surviving spouse or child been incarcerated for more than 60 days as a result of a conviction (38 U.S.C 5313)?',
  survivingBeneficiaryIncarceratedLabels: {
    yes: 'Yes',
    no: 'No',
  },
  survivingBeneficiaryIncarceratedDescriptions: {
    yes: 'If yes, answer the 3 follow-on questions about this incarceration',
  },
  survivingBeneficiaryIncarceratedError:
    'Select “Yes” or “No” to tell us if the surviving spouse or child is in jail or prison',
  survivingBeneficiaryFacilityNameTitle:
    'Name of facility where the surviving spouse or child beneficiary is incarcerated',
  survivingBeneficiaryFacilityNameError:
    'Enter the name of the incarceration facility',
  survivingBeneficiaryFacilityAddressError:
    'Enter the incarceration facility address',

  // Page 4
  veteranCompetencePageTitle: 'Veteran competence',
  veteranCompetenceCriteriaLabel:
    'Are the following reasons for the benefit apportionment true:',
  veteranCompetenceHintText:
    'If these are the reasons for the apportionment, select “Yes” and answer the 2 follow-on questions about the Veteran’s competence',
  veteranCompetenceLabels: {
    yes: 'Yes',
    no: 'No',
  },
  veteranCompetenceDescriptions: {
    yes: 'These are the reasons for the benefit apportionment',
    no: 'These are not the reasons for the benefit apportionment',
  },
  veteranCompetenceError:
    'Select “Yes” or “No” to confirm these are the reasons for claiming part of the Veteran’s benefits',
  veteranCareFacilityNameTitle:
    'Name of facility where the Veteran beneficiary is receiving care',
  veteranCompetenceFacilityNameError:
    'Enter the name of the facility where care is provided',
  veteranCompetenceFacilityAddressError: 'Enter the facility address',

  // Page 5
  veteranSupportPageTitle: 'Veteran support and medical care',
  veteranReceivingPensionInCareTitle:
    'Is the Veteran in receipt of pension (monthly financial support from VA) and receiving hospital, domiciliary (in home) or nursing home care by the United States (Federal) or a political subdivision (State or local)? (38 U.S.C. 5503)',
  veteranSupportHintText:
    'If the Veteran is in receipt of pension and receiving medical care, select “Yes” and answer the 2 follow-on questions',
  veteranPensionLabels: {
    yes: 'Yes',
    no: 'No',
  },
  veteranPensionDescriptions: {
    yes: 'The Veteran is in receipt of pension and is receiving medical care by the United States or a political subdivision',
    no: 'The Veteran is not in receipt of pension and is not receiving medical care by the United States or a political subdivision',
  },
  veteranPensionError:
    'Select “Yes” or “No” to tell us if the Veteran receives VA pension and medical care',
  veteranPensionFacilityNameError:
    'Enter the name of the facility where care is provided',
  veteranPensionFacilityAddressError: 'Enter the facility address',

  // Page 6
  beneficiaryRestrictedAreaPageTitle: 'Beneficiary lives in a restricted area',
  beneficiaryInEnemyTerritoryTitle:
    'Does the primary beneficiary reside in the territory of or under control of an enemy of the United States or its allies? (38 U.S.C 5308)',
  beneficiaryInEnemyTerritoryError:
    'Select “Yes” or “No” to tell us if the person receiving benefits lives in a restricted area',

  // Page 7
  veteranMissingPageTitle: 'Veteran is missing',
  veteranDisappearedTitle:
    'Has the Veteran disappeared for 90 days or more and their whereabouts remain unknown?',
  veteranDisappearedError:
    'Select “Yes” or “No” to tell us if the Veteran is missing',

  // Page 8
  importantInformationPageTitle: 'Important information',
  importantInfoAlertText:
    'Based on your responses to the questions about reasons for your apportionment claim, please tell us more about your situation using the “Remarks” field on the following screen.',

  facilityAddressTitle: 'Address of facility',

  yesNoLabels: {
    yes: 'Yes',
    no: 'No',
  },
  yesNoError: 'Select either “Yes” or “No”',
};

export const remarksText = {
  pageTitle: 'Remarks',
  pageDescription:
    "You can use this space to provide details about the reasons for your apportionment claim or enter any additional information you'd like us to know.",
  remarksTitle: '(Optional)',
};

export const certificationText = {
  pageTitle: 'Certification',
  pageDescription:
    'Select the checkbox to certify that you have completed this statement and that its information is true and correct to the best of your knowledge and belief.',
  certifyTitle:
    'I certify that I have completed this statement and that its information is true and correct to the best of my knowledge and belief.',
  certifyError: 'Select this checkbox to acknowledge this certification',
  penaltyHeadline: 'Penalty',
  penaltyBody:
    'The law provides severe penalties which include fine or imprisonment or both, for the willful submission of any statement or evidence of a material fact, knowing it to be false, or fraudulent acceptance of any payment to which you are not entitled.',
};

export const formConfigText = {
  statementOfTruthHeading: 'Statement of truth',
  statementOfTruth:
    'I confirm that the identifying information in this form is accurate and has been represented correctly.',
  inProgressMessage:
    "Your request for apportionment of a beneficiary's award is in progress.",
  expiredMessage:
    "Your saved request for apportionment of a beneficiary's award has expired.",
  savedMessage:
    "Your request for apportionment of a beneficiary's award has been saved.",
  notFoundMessage:
    "Please start over to complete your request for apportionment of a beneficiary's award.",
  noAuthMessage:
    "Please sign in again to continue your request for apportionment of a beneficiary's award.",
  appType: 'application for apportionment of a beneficiary’s award',
  submitButtonText: 'Submit Application',
};
